import React from 'react';
import { VStack } from 'native-base';
import { GIFTCARD_FLOWS, observer, useSpringBigStore } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const AddGiftCard = () => {

    const { merchant } = useSpringBigStore();

    return (
        <VStack space={4}>
            <Caption
                text={'giftCard.add.title'}
                textValues={[merchant?.gift_card_alias]}
                textAlign={'center'}
                fontSize={24}
            />
            <Button
                fontSize={18}
                text={'giftCard.add.uploadButton'}
                textValues={[merchant?.gift_card_alias]}
                onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.existingGiftCard)}
            />
            {/* remove ability to purchase GC altogether */}
            {/*<Button*/}
            {/*    fontSize={18}*/}
            {/*    text={'giftCard.add.fundButton'}*/}
            {/*    textValues={[merchant?.gift_card_alias]}*/}
            {/*    onPress={() => observer.emit('change-screen', GIFTCARD_FLOWS.addFunds)}*/}
            {/*/>*/}
        </VStack>
    );
};

export default AddGiftCard;
